import {waAction} from '../../common/wastat';

export function showStat() {
  waAction({
    ac_name: 'appear',
    ac_type: 'share',
    pos: 'bottom',
  });
}

export function clickStat() {
  waAction({
    ac_name: 'click',
    ac_type: 'share',
    pos: 'bottom',
  });
}
